import React from "react";

export default function Privacy() {
  return (
    <div className="page">
      <section className="section">
        <div className="docs__markdown">
          <h1>Privacy Policy</h1>
          <p>
            This privacy policy sets out how Lyket uses and protects any
            information that you give Lyket when you use this website. Lyket is
            committed to ensuring that your privacy is protected and it is one
            of the first priorities of our service.
          </p>
          <p>
            Should we ask you to provide certain information by which you can be
            identified when using this website, then you can be assured that it
            will only be used in accordance with this privacy statement.
          </p>
          <p>
            Lyket may change this policy from time to time by updating this
            page. You should check this page from time to time to ensure that
            you are happy with any changes. This policy is effective from
            20/07/2020. We may collect the following information:
          </p>
          <ul>
            <li>Google Analytics info</li>
            <li>Your IP Address</li>
            <li>Your name, email, role and company if you submit the form.</li>
          </ul>
          <h4>When using the buttons</h4>
          <p>
            When you use the buttons no info about you is requested. Only the IP
            is saved in order to recognise if a vote from the same IP has been
            made.
          </p>
          <p>
            We will save the information you submit to us until you remove or
            change the information, or until when remove your user account.
            Information related to the login method you choose is saved until
            you remove your user account.
          </p>
          <p>
            What we do with the information we gather We require this
            information to understand your needs and provide you with a better
            service, and in particular for the following reasons:
          </p>
          <p>
            <li>
              Internal record keeping, mostly to combat spam and prevent abuse
            </li>
            <li>
              We may use the information to improve our products and services{" "}
            </li>
            <li>
              We may rarely send email about new features or other information
              which we think you may find interesting using the email address
              which you have provided.
            </li>
          </p>
        </div>
      </section>
    </div>
  );
}
